export const INTERVIEW_FORMAT_TEMPLATE_MODEL = "interview-format-template";

const interviewFormatTemplateModel = {
  interviewName: "",
  interviewerDetails: "",
  candidateDetails: "",
  duration: 0,
  tags: [],
  organisation: {
    jsonApi: "hasOne",
    type: "organisations"
  }
};

export default interviewFormatTemplateModel;
